import { GlobalConstants } from '../constants/global-constants'

const MODULE_FALLBACK_ORDER: { module: string; route: string }[] = [
  { module: 'DASHBOARD', route: `/${GlobalConstants.ROUTING.DASHBOARD}` },
  { module: 'ACTIVITY_TRACKER', route: `/${GlobalConstants.ROUTING.ACTIVITY}/${GlobalConstants.ROUTING.DASHBOARD}` },
  { module: 'GOVERNMENT_BUSINESS_TASK', route: `/${GlobalConstants.ROUTING.GOVERNMENT_BUSINESS}/${GlobalConstants.ROUTING.DASHBOARD}` },
  { module: 'QUERIES', route: `/${GlobalConstants.ROUTING.QUERY}/${GlobalConstants.ROUTING.DASHBOARD}` },
  { module: 'OFFLINE_TRACKER', route: `/${GlobalConstants.ROUTING.OFFLINE_TRACKER}/${GlobalConstants.ROUTING.SUMMARY}` },
  { module: 'CALENDAR', route: `/${GlobalConstants.ROUTING.CALENDAR_INFO}/${GlobalConstants.ROUTING.SUMMARY}` },
  { module: 'CIRCULARS_AND_ANNOUNCEMENTS', route: `/${GlobalConstants.ROUTING.ANNOUNCEMENT}/${GlobalConstants.ROUTING.SUMMARY}` },
  { module: 'KNOWLEDGE_BANK', route: `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.SEARCH}` },
]

const DEFAULT_FALLBACK = `/${GlobalConstants.ROUTING.EMPLOYEE_INFO}/${GlobalConstants.ROUTING.SUMMARY}`

export function getFirstAvailableRoute(enabledModules: string[]): string {
  for (const entry of MODULE_FALLBACK_ORDER) {
    if (enabledModules.includes(entry.module)) {
      return entry.route
    }
  }
  return DEFAULT_FALLBACK
}
